import React from "react";
import Layout from "./../components/Layout";
import "../styles/HomeStyles.css";
import dogimg from "../assets/images/dog.svg";
import user from "../assets/images/user.svg";
import { useNavigate } from "react-router-dom";
import { TruncateText } from '../functions/utilities/generic';
import {
  Box,
  Typography,
  Grid,
  Button,
} from "@mui/material";

const Home = () => {
  const navigate = useNavigate();
  const handleMenuClick = () => navigate("/About", { replace: true });

  return (
    <Layout>
      <Box sx={{ padding: 2 }}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="center"
        >
          {/* Text */}
          <Grid
            item
            xs={12}
            sm={6}
            md={5}
            sx={{
              textAlign: { xs: 'center', sm: 'left' },
              '@media (max-width:600px)': { // Mobile
                order: 2, // Move above image on mobile
              },
            }}
          >
            <Typography
              // variant="h1"
              align="left"
              sx={{
                textAlign: { fontFamily: 'Baloo Bhaijaan', color: '#3A54B4', xs: 'center', sm: 'left' },
                '@media (max-width:600px)': { // Mobile
                  order: 2, // Move above image on mobile
                },
                fontSize: { xs: '60px', sm: '80px', md: '100px' },

              }}

            >
              <b>Practical Pet Parenting</b>
            </Typography>
            <Typography
              variant="h3"
              align="left"
              sx={{
                textAlign: { fontFamily: 'Baloo Bhaijaan', color: '#3a54b4', xs: 'center', sm: 'left' },
                '@media (max-width:600px)': { // Mobile
                  order: 2, // Move above image on mobile
                },
                fontSize: { xs: '20px', sm: '24px', md: '48px' },
                fontWeight: 700,
              }}
            >
              Making pet parenting easier
            </Typography>
            <br />
            <Typography variant="body1" align="left"
              sx={{
                fontFamily: 'Baloo Bhaijaan',
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: '1rem', sm: '1rem', md: '1.5rem' },
              }}>
              If you're a pet parent running around the internet for reliable information, welcome! Here you'll find reliable, accessible and practical tips to make your pet parenting journey that little bit sweeter. As a vet and a pet parent myself, I'm right there with you on your struggles, and am here to ease the path for all of us!
            </Typography>
          </Grid>
          {/* Image */}
          <Grid
            item
            xs={12}
            sm={6}
            md={5}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              '@media (max-width:600px)': { // Mobile
                order: 1, // Move below text on mobile
              },
            }}
          >
            <img
              src={dogimg}
              alt="description"
              style={{
                borderRadius: '50%',
                maxWidth: '100%',
                height: 'auto',
              }}
            />
          </Grid>
        </Grid>
      </Box>

      {/* About Section */}
      <Box sx={{ padding: 2 }}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="center"
        >
          {/* Image */}
          <Grid
            item
            xs={12}
            sm={6}
            md={5}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              '@media (max-width:600px)': { // Mobile
                order: 1, // Move below text on mobile
              },
            }}
          >
            <img
              src={user}
              alt="description"
              style={{
                borderRadius: '50%',
                maxWidth: '100%',
                height: 'auto'
              }}
            />
          </Grid>

          {/* Text */}
          <Grid
            item
            xs={12}
            sm={6}
            md={5}
            sx={{
              textAlign: { xs: 'center', sm: 'left' },
              '@media (max-width:600px)': { // Mobile
                order: 1, // Move above image on mobile
              },
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Baloo Bhaijaan',
                textAlign: { xs: 'center', sm: 'left' },
                color: '#3a54b4',
                fontSize: { xs: '60px', sm: '60px', md: '100px' },
              }}
            >
              <b>About Me</b>
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Baloo Bhaijaan',
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: '1rem', sm: '1rem', md: '1.5rem' },
              }}
            >
              <TruncateText text={"I'm Dr. Ashitha Suresh,  When I was seven, I decided I was going to be an Animal Doctor, years before I learnt the word veterinarian. 2 decades later, here I am. Dog and cat health was and will always be my calling, and my goal is to use the knowledge I have gained (from all my years of education and being a pet parent myself), to help pet parents make their pets happier and healthier, and reap the benefits of the human animal bond. Whether you're a new pet parent, a seasoned pet parent, or contemplating the decision, we all have something new to learn from our animals every single day. I’m so glad to have you on this crazy hard, but deeply fulfilling journey!"}></TruncateText>
              <br />
            </Typography>
            <br />
            <Button
              size="large"
              variant="contained"
              onClick={handleMenuClick}
            >Read More
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Layout >
  );
};

export default Home;
